import { MARQUEE_ITEMS } from "@/data/content";

export const Marquee = () => (
    <section data-testid="editorial-marquee" aria-hidden className="overflow-hidden border-y border-wood/10 bg-sand py-6">
        <div className="animate-marquee flex w-max">
            {[0, 1].map((half) => (
                <div key={half} className="flex shrink-0 items-center">
                    {MARQUEE_ITEMS.map((item) => (
                        <span key={`${half}-${item}`} className="flex items-center">
                            <span className="whitespace-nowrap px-10 font-serif text-xl italic text-wood/60 sm:text-2xl">
                                {item}
                            </span>
                            <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" />
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </section>
);
